import { createFileRoute } from "@tanstack/react-router";
import AdminImagesPage from "@/admin/pages/images";

export const Route = createFileRoute("/admin/images/")({
  component: AdminImagesPage,
});
